import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import DataState from '../../components/DataState';
import SocialBlock from '../../components/SocialBlock';
import { mediaPicture } from '../../data/images';
import { useCollections } from '../../lib/api/collections';

const TYPES = [
  ['campus-life', 'Campus life'],
  ['graduation', 'Graduation'],
  ['video', 'Videos'],
  ['other', 'Other'],
];

const GalleryMain = () => {
  const content = useCollections('gallery');
  const [params, setParams] = useSearchParams();
  if (content.loading || content.error) return <DataState state={content} />;

  const type = params.get('type');
  const present = TYPES.filter(([value]) => content.gallery.some((a) => a.type === value));
  const albums = type ? content.gallery.filter((a) => a.type === type) : content.gallery;

  return (
    <main>
      <Breadcrumb title="Gallery" subTitle="Gallery" />
      <div className="sc-listing pt-120 pb-90">
        <div className="container">
          {present.length > 1 && (
            <div className="sc-pills" role="tablist" aria-label="Album kinds">
              <button type="button" className={!type ? 'active' : ''} onClick={() => setParams({})}>All</button>
              {present.map(([value, label]) => (
                <button key={value} type="button" className={type === value ? 'active' : ''} onClick={() => setParams({ type: value })}>{label}</button>
              ))}
            </div>
          )}
          {albums.length === 0 ? (
            <div className="sc-empty-state">
              <h4>The gallery is being prepared</h4>
              <p>Photos and videos of campus life and graduations will be shown here soon.</p>
            </div>
          ) : (
            <div className="row">
              {albums.map((a) => {
                const firstPhoto = a.items.find((i) => i.kind === 'image' && i.path);
                const cover = a.coverPath || (firstPhoto && firstPhoto.path);
                return (
                  <div key={a.id} className="col-xl-4 col-lg-4 col-md-6 mb-30">
                    <Link to={`/gallery/${a.id}`} className="sc-pcard">
                      <div className="sc-pcard__img">
                        <img src={mediaPicture(cover)} alt="" loading="lazy" />
                        <span className="sc-pcard__tag">{(TYPES.find(([v]) => v === a.type) || [])[1] || 'Album'}</span>
                      </div>
                      <div className="sc-pcard__body">
                        <small>{a.items.length} item{a.items.length === 1 ? '' : 's'}</small>
                        <h4>{a.title}</h4>
                        {a.description && <p>{a.description}</p>}
                        <span className="sc-pcard__more">Open album &rarr;</span>
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          )}
          <SocialBlock />
        </div>
      </div>
    </main>
  );
};

export default GalleryMain;
